// 市场实时价格信息
<template>
    <div class="component-container">
        <img class="banner" style="z-index: -1" src="@/assets/images/bg-pic.png" alt="" />
        <div class="marketPrice">过磅实时信息</div>
        <!--    <span class="bg-pic"><img src="@/assets/images/bg-pic.png" alt="" /></span>-->
        <!-- 价格展示 -->
        <div>
            <div class="titleText">
                <span style="flex-basis: 16.6%; text-align: center">车牌号</span>
                <span style="flex-basis: 16.6%; text-align: center">客户名称</span>
                <span style="flex-basis: 16.6%; text-align: center">进场时间</span>
                <span style="flex-basis: 16.6%; text-align: center">毛重(公斤)</span>
                <span style="flex-basis: 16.6%; text-align: center">皮重(公斤)</span>
                <span style="flex-basis: 16.6%; text-align: center">净重(公斤)</span>
            </div>

            <vue-seamless-scroll :data="priceInfoList" :class-option="optionHover" class="seamless-warp">
                <ul class="item">
                    <li class="priceInfo" v-for="(item, index) in priceInfoList" :key="index">
                        <span style="flex-basis: 16.6%; text-align: center">
                            {{ item.carNo }}
                        </span>
                        <span style="flex-basis: 16.6%; text-align: center">
                            {{ item.customerName }}
                        </span>
                        <span style="flex-basis: 16.6%; text-align: center">
                            {{ item.inTime.slice(10,20) }}
                        </span>
                        <span style="flex-basis: 16.6%; text-align: center">
                            {{ item.totalWeight }}
                        </span>
                        <span style="flex-basis: 16.6%; text-align: center">
                            {{ item.tare }}
                        </span>
                        <span style="flex-basis: 16.6%; text-align: center">
                            {{ item.netWeight }}
                        </span>
                    </li>
                </ul>
            </vue-seamless-scroll>
        </div>
    </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";

import { mapState } from "vuex";
export default {
    data () {
        return {
            scrollTimer: null, // 滚动定时器
            pauseTimer: null, // 暂停定时器
            scrollId: "scrollId", // 滚动容器id
            scrollDirection: "down", // 滚动方向 up向上 down向下
            priceInfoList: [],
        };
    },
    components: {
        vueSeamlessScroll,
    },
    computed: {
        optionHover () {
            return {
                hoverStop: true,
                step: 0.1,
            };
        },
        ...mapState(["dateType"]),
    },
    watch: {
        dateType (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getData();
            }
        },
    },
    mounted () {
        this.getData();
        // console.log(this.dateType);
    },
    destroyed () { },
    methods: {
        //获取后台的数据
        async getData () {
            await this.$http
                .get("/screen/getCarInListOnlyFiveDataList?type=" + this.dateType, {})
                .then((response) => {
                    if (response.data.resultCode === 200) {
                        // console.log(response, "------------");
                        this.priceInfoList = response.data.inList;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>

<style scoped>
/*.container {*/
/*  width: 100%;*/
/*  height: 270px;*/
/*  background-image: url(@/assets/images/bg-vehicle.png);*/
/*  position: relative;*/
/*  color: #04deff;*/
/*}*/
.component-container {
    color: #04deff;
    overflow: hidden;
    font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
        "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
}

.seamless-warp {
    /*height: 180px;*/
    overflow: hidden;
}

.item {
    /*height: 180px;*/
    margin: 0;
    padding: 0;
}
.marketPrice {
    font-size: 18px;
    font-weight: 800;
    padding: 6px 0 0 17px;
    z-index: 1000;
}
.bg-pic {
    position: absolute;
    top: 30px;
    left: 35px;
    opacity: 0.55;
}
.titleText {
    width: 97%;
    height: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #fff;
    background: #021844;
    font-size: 18px;
    margin: 7px 1% 0 1%;
}
.priceInfo {
    list-style: none;
    display: flex;
    height: 35px;
    justify-content: space-around;
    font-size: 17px;
}
</style>
